import { render, staticRenderFns } from "./Violacoes.vue?vue&type=template&id=439b7730&scoped=true"
import script from "./Violacoes.vue?vue&type=script&lang=js"
export * from "./Violacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439b7730",
  null
  
)

export default component.exports